import store from "@/store";
import layout from "@/layouts/PanelManager.vue";

import { routes as blogRoutes } from "./blog/Routes";
import { routes as operatorsRoutes } from "./operators/Routes";
import { routes as managersRoutes } from "./managers/Routes";
import { routes as eventsRoutes } from "./events/Routes";
import { routes as pagesRoutes } from "./pages/Routes";
import { routes as authRoutes } from "./auth/Routes";

import { routes as languagesRoutes } from "./Languages/Routes";
import { routes as preferencesRoutes } from "./preferences/Routes";
import { routes as dossiersRoutes } from "./dossiers/Routes";
import { routes as analyticsRoutes } from "./analytics/Routes";
import { routes as monitoringRoutes } from "./monitoring/Routes";
import { routes as historyRoutes } from "./history/Routes";
import { routes as organizationRoutes } from "./organization/Routes";
import { routes as jobsRoutes } from "./jobs/Routes";
import { routes as zonesRoutes } from "./zones/Routes";
import { routes as devicesRoutes } from "./devices/Routes";
import { routes as routesRandomNumberRequests } from "./randomNumberRequests/Routes";
import { routes as routesUsers } from "./users/Routes";
import { routes as routesTransactions } from "./transactions/Routes";
import { routes as podcastRoutes } from "./podcast/Routes";
import { routes as routesVideo } from "./video/Routes";
import { routes as routesGames } from "./games/Routes";
import { routes as routesWebinar } from "./webinar/Routes";
import { routes as routesOrders } from "./orders/Routes";
import { routes as routesWithdraws } from "./widthraw/Routes";
import { routes as routesGldtogld } from "./gldtogld/Routes";
import { routes as routesManualPayments } from "./manualPayments/Routes";
import { routes as routesTickets } from "./tickets/Routes";

const groupName =
  store.state
    .managerRoutesGroupName; /* نام گروه کابری برای مدیریت داشبرد یا پنل مورد نظر */
const pathRoot =
  store.state
    .managerRoutesPathRoot; /* مسیری ریشه‌ای که برای گروه کاربری در نظر گرفته‌ایم */
const parentName =
  store.state
    .managerRoutesParentName; /* نام اصلی برای زیر مسیر‌های مدیریت داشبرد یا پنل مورد نظر */
// ------- Routes -------- -------- -------- -------- -------- -------- -------- //
export const routes = [
  {
    name: parentName,
    path: pathRoot,
    component: layout,
    meta: {
      requiresAuth: true,
      group: groupName,
    },
    children: [
      {path:"financial-limits",name:parentName+"-FinancialLimits",component:()=>import("@/components/FinancialPolicySettings.vue")},
      {path: "seo", name: parentName + "-Seo", component: () => import("./Seo.vue")},
      {path: "security-services", name: parentName + "-SecurityServices", component: () => import("./SecurityServices.vue")},
      ...operatorsRoutes(parentName),
      ...managersRoutes(parentName),
      ...eventsRoutes(parentName),
      ...zonesRoutes(parentName),
      ...blogRoutes(parentName),
      ...podcastRoutes(parentName),
      ...pagesRoutes(parentName),

      ...languagesRoutes(parentName),
      ...preferencesRoutes(parentName),
      ...dossiersRoutes(parentName),
      ...analyticsRoutes(parentName),
      ...monitoringRoutes(parentName),
      ...historyRoutes(parentName),
      ...organizationRoutes(parentName),
      ...jobsRoutes(parentName),
      ...devicesRoutes(parentName),
      ...routesRandomNumberRequests(parentName),
      ...routesUsers(parentName),
      ...routesTransactions(parentName),
      ...routesVideo(parentName),
      ...routesGames(parentName),
      ...routesWebinar(parentName),
      ...routesOrders(parentName),
      ...routesWithdraws(parentName),
      // Logs routes (inline to avoid external file dependency)
      {
        path: "logs",
        name: `${parentName}-Logs`,
        component: () => import("./otpLogs/List.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "logs/:source/:id",
        name: `${parentName}-Logs-View`,
        component: () => import("./otpLogs/View.vue"),
        meta: { requiresAuth: true },
      },
      ...routesGldtogld(parentName),
      ...routesManualPayments(parentName),
      ...routesTickets(parentName),
      {
        path: "products",
        name: parentName + "-Products",
        component: () => import("./Products.vue"),
      },
      {
        path: "product-orders",
        name: parentName + "-ProductOrders",
        component: () => import("./ProductOrders.vue"),
      },
      {
        path: "site-cms",
        name: parentName + "-SiteCms",
        component: () => import("./SiteCms.vue"),
      },
      {
        path: "",
        redirect: {
          name: parentName + "-" + "Home",
        },
      },

      {
        path: "home",
        name: parentName + "-" + "Home",
        component: () => import("./AccessHome.vue"),
      },

      {
        path: "admin-dashboard",
        name: parentName + "-" + "AdminDashboard",
        component: () => import("./AdminDashboard.vue"),
      },
      {
        path: "financial-balance",
        name: parentName + "-FinancialBalance",
        component: () => import("./FinancialBalance.vue"),
        meta: { requiresAuth: true, permission: "finance.view" },
      },

      {
        path: "message-list",
        name: parentName + "-" + "MessageList",
        component: () => import("./MessageList.vue"),
      },

      // -------- Language ------- ------- ------- ------- ------- ------- ------- //
      //  {
      //   path: "languages",
      //   name: parentName + "-" + "Languages",
      //   component: () => import("./Languages.vue"),
      // },
      // -------- END Language ------- ------- ------- ------- ------- ------- ------- //

      {
        path: "profile",
        name: parentName + "-" + "Profile",
        component: () => import("./Profile.vue"),
      },

      {
        path: "Settings",
        name: parentName + "-" + "Settings",
        component: () => import("./Settings.vue"),
      },
    ],
  },

  // ####### Auth ####### ####### ####### ####### ####### ####### ####### ####### //
  /**
   * مهم:
   * چون لاگین و رجیستر از لایه پیشفرض گروه مدیریت پیروی نمی‌کنند باید خارج از فضای چیلدرن نوشته شود
   */

  ...authRoutes(parentName, pathRoot, groupName),
  // ####### END Auth ####### ####### ####### ####### ####### ####### ####### ####### //
];

// ------- END Routes -------- -------- -------- -------- -------- -------- -------- //

export const middleware = (record, next, checkAuth) => {
  // ------- Check Group ------- ------- ------- ------- ------- ------- ------- //
  if (record.meta.group === groupName) {
    // ------- Check Auth ------- ------- ------- ------- ------- ------- ------- //
    if (record.meta.requiresAuth) {
      console.log("SALAMA!");
      //const redirectPath = window.location.pathname; // برگشت به آدرس این صفحه
      if (checkAuth) {
        next();
      } else {
        next({
          name: `${parentName}-Login`,
          query: { redirect: window.location.pathname },
        });
      }
    }
    // ####### END Check Auth ####### ####### ####### ####### ####### ####### ####### //

    // ------- Check Auth Reverse ------- ------- ------- ------- ------- ------- ------- //
    else if (record.meta.requiresAuthReverse) {
      if (!checkAuth) {
        next();
      } else {
        next({
          name: `${parentName}-Login`,
        });
      }
    }
    // ####### END Check Auth  Reverse ####### ####### ####### ####### ####### ####### #######  //
  }
  // ####### END Check Group ####### ####### ####### ####### ####### ####### ####### //
};
